<template>
  <div class="mb-12">
    <template v-for="(sdsOrder, index) in sdsOrder">
      <div class="flex flex-row title-border mb-2 lg:mb-2 gap-x-4">
        <h4 class="font-normal text-base md:text-lg lg:text-xl mb-0">{{ sdsOrder.customId }}</h4>
        <span :class="`text-xs ${getStatusColor(sdsOrder.status)}`">{{ getStatusText(sdsOrder.status) }}</span>
      </div>
    <div class="ds-wrapper mb-4">
      <vs-table :data="sdsOrder.sdsOrderItems" class="sds-order-table stripes">
        <template slot="thead">
          <vs-th width="90%">
            <label class="text-normal">Item</label>
          </vs-th>
          <vs-th width="10%" class="text-right">
            <label class="text-normal">Cost</label>
          </vs-th>
        </template>
          <vs-tr :key="indextr" v-for="(data, indextr) in sdsOrder.sdsOrderItems">
            <vs-td :data="data.description">
              {{ data.description }}
            </vs-td>
            <vs-td :data="data.cost" class="text-right">
              {{ formatCurrency(data.cost) }}
            </vs-td>
          </vs-tr>
        <vs-tr>
          <vs-td class="font-bold">Total</vs-td>
          <vs-td class="font-bold">{{ formatCurrency(totalOrderAmount(sdsOrder.sdsOrderItems)) }}</vs-td>
        </vs-tr>
      </vs-table>
    </div>
  </template>
  </div>
</template>

<script>
  export default {
    props: {
      sdsOrder: { type: Array },
    },

    methods: {
      totalOrderAmount(orderItems) {
        let orderAmount = orderItems.reduce((accumulator, currentValue) => {
          return accumulator + parseFloat(currentValue.cost.toFixed(2));
        }, 0);

        return orderAmount;
      },

      getStatusColor(status) {
        let colorClass;

        switch (status) {
          case "Cancelled":
            colorClass = "badge danger";
            break;
          case "Completed":
          case "Confirmed":
          case "Received":
          case "Sent":
            colorClass = "badge success";
            break;
          case "Pending":
            colorClass = "badge pending";
            break;
        }

        return colorClass;
      },

      getStatusText(status) {
        let statusText = status;

        if (["Completed", "Confirmed", "Received", "Sent"].includes(status)) {
          statusText = "Paid";
        }

        return statusText;
      },
    }
  }
</script>

